module.exports = __webpack_public_path__ + "img/img_desk_tabl.608645d7.png";